import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import HTMLReactParser from "html-react-parser";
import dateFormat from "dateformat";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Loader from "../../Loader/Loader";

const HomeNewsDetails = () => {
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch(`https://api.wlffinance.org/api/frontend/home/news/view/${id}`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        setData(data?.data);
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return (
      <>
        <Loader></Loader>
      </>
    );
  } else {
    return (
      <>
        <div className="mobile-news-details-section news-details-area">
          <div className="container">
            <div className="news-details">
              <div className="news-details-title text-end">
                <Link to="/user/news">View all news</Link>
              </div>

              <main>
                <div className="news-details-main">
                  <LazyLoadImage
                    alt="img"
                    effect="blur"
                    className=""
                    src={`https://api.wlffinance.org/${data?.image}`}
                  />
                  <div className="news-title  text-center">
                    <h5>{data?.title}</h5>
                  </div>
                  <div className="news-details-time">
                    <span>{dateFormat(data.createdAt, "d/m/yyyy")}</span>
                  </div>
                  <div className="news-detail-all">
                    <p className="mb-2 news-detail-short_dis">{data?.dis}</p>
                    {data?.news ? HTMLReactParser(data?.news) : ""}
                  </div>
                </div>
              </main>
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default HomeNewsDetails;
